export default "__VITE_ASSET__DuMo0QIk__"